import { ComponentProps, forwardRef } from 'react';
import { cn } from '../utils/className';
import { IconButton } from './IconButton';

type AppBarIconButtonProps = Omit<ComponentProps<typeof IconButton>, 'shape'>;

/** An icon button for the blue app bar, lifted off it by a translucent white. */
export const AppBarIconButton = forwardRef<
  HTMLButtonElement,
  AppBarIconButtonProps
>(({ className, ...props }, ref) => (
  <IconButton
    ref={ref}
    shape='square'
    className={cn(
      'bg-inverted/10 text-inverted hover:bg-inverted/20 size-10.5 rounded',
      className
    )}
    {...props}
  />
));

AppBarIconButton.displayName = 'AppBarIconButton';
